import { createStore } from "vuex";
import game from "./modules/game";
import user from "./modules/user";

export default createStore({
	getters: {
		mocking: () => true,
		fullState: () => {
			return {
				...game.state,
				...user.state,
			};
		},
	},
	modules: {
		game,
		user,
	},
});
